import { useState } from 'react';
import { Button } from "../../../../../core/components/atoms/Button";
import { Typography } from "../../../../../core/components/molecules/Typography";
import { AboutPlanModal } from '../../AboutPlanModal';

interface IHubHeader {
  title: string;
  version: string;
  createdAt: string;
  onAdjustSchedule: () => void;
}

const HubHeader = ({ title, version, createdAt, onAdjustSchedule }: IHubHeader) => {
  const [isAboutPlanModalOpen, setIsAboutPlanModalOpen] = useState(false);

  return (
    <div className='flex flex-col xl:flex-row justify-between gap-md xl:gap-0 xl:items-center' data-tour="hub-header">
      <div className="flex flex-col lg:gap-1">
        <Typography type='title' className="text-h3 md:text-h2 text-mono-color-darkest" >
          {title}
        </Typography>
        <Typography size="mini" className="italic">
          <span className="dark:text-button-color-tertiary-default text-brand-color-primary-pure not-italic mr-2"> 
            Versão {version} 
          </span> Criado em {createdAt}
        </Typography>
      </div>
      {/*<Button LeftIcon='edit' iconType='material' onClick={onAdjustSchedule}>*/}
      {/*  Ajustar cronograma*/}
      {/*</Button>*/}
      <div className='flex flex-col items-start gap-sm xl:items-end'>
        <Button
          variant='text'
          LeftIcon='info'
          iconType='material'
          iconSize='small'
          className='p-0 text-md md:text-md'
          onClick={() => setIsAboutPlanModalOpen(true)}
        >
          Como funciona
        </Button>
        <Button LeftIcon='delete' iconType='material' onClick={onAdjustSchedule}>
          Excluir cronograma
        </Button>
      </div>
      <AboutPlanModal
        isOpen={isAboutPlanModalOpen}
        onClose={() => setIsAboutPlanModalOpen(false)}
      />
      {/*<Button LeftIcon='delete' iconType='material' onClick={onAdjustSchedule}>*/}
      {/*  Excluir cronograma*/}
      {/*</Button>*/}
    </div>
  );
};

export default HubHeader;
